// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"186":"fbb37f39","708":"fbb37f39","905":"fbb37f39"}[chunkId] + ".chunk.css";
};